(function () {
    var config = {
        usagePlanName: {
            required: true,
            rangelength: [1, 64]
        },

        desc: {
            rangelength: [0, 256]
        }
    };
    RCDPW.module('RCDPW.validator.rules.administration.usagePlanForm', config);
})();
